import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SetStyles } from "../.././MyHelpers";
import { FontResource } from "../../ResourceManager/FontResource";
import { SlideFactory } from "../Slider/SecondScreenHelp"; 
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { FreegameBonusFactory2 , FreegameBonus2 , FreegameBonus2Params} from "../FreegameBonus/FreegameBonus2";
import { FreegamesCommonConfiguration } from "../../api";

// namespace SlotGames2
// {
	export class FiestaEnchilada2 extends SlotGameType1_2
	{
   
		protected override seconScreenHelpFactory:ISlideFactoryGeneric = new FactoryDoubleSlide();
		////protected override freegameBonusFactory: FreegameBonusFactory2 = new FiestaEnchiladaFreegame2BonusFactory();
	    protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
        {
        	super.PaytableLoaded(resourceManager);
        	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});


        }
		
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
		


		
	}

	class FiestaEnchilada2Freegame extends FreegameBonus2 
	{

		public override async PrepareFonts(resourceManager: ResourceManager)
		{
			
			resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", "." + this.resid.ScopedResourceName("font")));
		}
		


	}


	class FiestaEnchiladaFreegame2BonusFactory extends FreegameBonusFactory2 
	{
		public override CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration,  p: FreegameBonus2Params): FreegameBonus2 
		{
			return new FiestaEnchilada2Freegame(gameName, freeGameConfig,  p);
		}
	}


	class FiestaEnchiladaSecondScreenHelpFactory extends SlideFactory
	{
		public override CreateStyle():Partial<CSSStyleDeclaration>
		{
			let style :Partial<CSSStyleDeclaration> = 
			{
				color:"White"
			};
			return style;
		}
	}
// }